import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.REMOVE_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/removeTrigger.js